/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationSourcesControllerCreateMutationRequest, ApplicationSourcesControllerCreateMutationResponse, ApplicationSourcesControllerCreate400, ApplicationSourcesControllerCreate401, ApplicationSourcesControllerCreate403 } from "../../models/checklistsController/ApplicationSourcesControllerCreate";

function getApplicationSourcesControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/checklist-application-sources` as const }  
  return res
}

/**
 * @summary Create a new checklist application source
 * {@link /api/v1/checklist-application-sources}
 */
export async function applicationSourcesControllerCreate(data?: ApplicationSourcesControllerCreateMutationRequest, config: Partial<RequestConfig<ApplicationSourcesControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ApplicationSourcesControllerCreateMutationResponse, ResponseErrorConfig<ApplicationSourcesControllerCreate400 | ApplicationSourcesControllerCreate401 | ApplicationSourcesControllerCreate403>, ApplicationSourcesControllerCreateMutationRequest>({ method : "POST", url : getApplicationSourcesControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}